import { useEffect, useState } from "react";

const PREFIX = "pf:";

// Stato conservato in sessionStorage finché l'utente non cambia sezione del portale.
export function usePersistedState(key, initial) {
  const [value, setValue] = useState(() => {
    try {
      const raw = sessionStorage.getItem(PREFIX + key);
      return raw !== null ? JSON.parse(raw) : initial;
    } catch {
      return initial;
    }
  });
  useEffect(() => {
    try { sessionStorage.setItem(PREFIX + key, JSON.stringify(value)); } catch { /* quota */ }
  }, [key, value]);
  return [value, setValue];
}

export function clearPersistedState(scope = "") {
  Object.keys(sessionStorage)
    .filter((k) => k.startsWith(PREFIX + scope))
    .forEach((k) => sessionStorage.removeItem(k));
}

// Ogni gruppo di filtri resta valido solo sulle pagine indicate.
const SCOPE_PAGES = {
  "storico:": [/^\/admin\/storico$/, /^\/admin\/foglio-cassa\/[^/]+$/],
  "storicovers:": [/^(\/admin)?\/storico-versamenti$/],
  "sospesi:": [/^(\/admin)?\/sospesi$/],
};

export function resetPersistedScopes(pathname) {
  Object.entries(SCOPE_PAGES).forEach(([scope, pages]) => {
    if (!pages.some((re) => re.test(pathname))) clearPersistedState(scope);
  });
}
